<br><br>
<app-gestiones-header-preca  [clienteserviceParam]="clienteserviceParam"[buttonselected]=1 [participante]="participante"
  [gestionSeleccionada]="precalificacionSeleccionada" (selecttab)="selectedtab($event)"
  (selectParticipante)="selectedparticipante($event)"></app-gestiones-header-preca>
<div class="container-fluid">
  <div class="row table-full">
    <div *ngIf="!clienteserviceParam.rolABFlag">
      <div class="producto" *ngIf="precalificacionSeleccionada.estadoProceso=='INTEGRADA_BT'">
        <div class="row">
          <div class="col-md-2">
            <h4 style="margin-top: 8px;">ESTADO</h4>
          </div>
          <div class="col-md-5">
            <h3 style="margin-top: 8px;">INGRESADA A BANCA</h3>
          </div>
          <div class="col-md-4">
  
          </div>
          <div class="col-md-1 p-0">
            <img src="../../assets/icons/Botones Politicas Verde.png" height="25px" class="vertical-center">
          </div>
        </div>
      </div>
      <div class="producto" *ngIf="precalificacionSeleccionada.estadoProceso=='OFERTA_SELECCIONADA'
      && precalificacionSeleccionada.estadoColorPrecalificacion=='VERDE'
      && participante === 0 && banderavencimiento">
        <div class="row">
          <div class="col-md-2" style="padding-right: 0px;">
            <h4>ESTADO</h4>
            <hr style="margin: 10px 0 10px 0;">
            <h4>MENSAJE</h4>
          </div>
          <div class="col-md-6 p-0">
            <h3>OFERTA SELECCIONADA</h3>
            <hr style="margin: 10px 0 10px 0;">
            <h3 style="margin-bottom: 0;">{{precalificacionSeleccionada.mensajeProceso}}</h3>
          </div>
          <div class="col-md-3 p-0">
            <button type="button" class="btn tabgestion center-relative" (click)="integrarAbanca()">ENVIAR A
              BANCA</button>
          </div>
          <div class="col-md-1 p-0">
            <img src="../../assets/icons/Botones Politicas rojo.png" height="25px" class="vertical-center">
          </div>
        </div>
      </div>
      <div class="producto" *ngIf="precalificacionSeleccionada.estadoProceso=='OFERTA_SELECCIONADA'
      && precalificacionSeleccionada.estadoColorPrecalificacion=='AMARILLO' && banderavencimiento">
        <div class="row">
          <div class="col-md-2" style="padding-right: 0px;">
            <h4>ESTADO</h4>
            <hr style="margin: 10px 0 10px 0;">
            <h4>MENSAJE</h4>
          </div>
          <div class="col-md-6 p-0">
            <h3>OFERTA SELECCIONADA</h3>
            <hr style="margin: 10px 0 10px 0;">
            <h3 *ngIf="!banderccrcodeudor" style="margin-bottom: 0;">La precalificación indicada que necesita autorización para ser integrada en
              banca BT </h3>
              <h3 *ngIf="banderccrcodeudor" style="margin-bottom: 0;">Codeudor no aplica por regla cancelación contra reserva.</h3>
          </div>
          <div class="col-md-3 p-0">
            <div *ngxPermissionsOnly="['autorizaciNCcr']" style="height: 100%;">
              <button  *ngIf="!banderccrcodeudor" type="button" class="btn tabgestion center-relative" (click)="openModalCcr()">AUTORIZAR</button>
            </div>
          </div>
          <div class="col-md-1 p-0">
            <img src="../../assets/icons/Boton Amarillo.png" height="25px" class="vertical-center">
          </div>
        </div>
      </div>
      <div class="producto" *ngIf="precalificacionSeleccionada.estadoProceso=='OFERTA_SELECCIONADA'
      && precalificacionSeleccionada.estadoColorPrecalificacion=='VERDE'
      && participante === 1
      && clienteserviceParam.datosCodeudor.cliente.existeClienteConCodigoBantrab === 'N' && banderavencimiento">
        <div class="row">
          <div class="col-md-2">
            <h4>ESTADO</h4>
            <hr style="margin: 10px 0 10px 0;">
            <h4>MENSAJE</h4>
          </div>
          <div class="col-md-6 p-0">
            <h3>OFERTA SELECCIONADA</h3>
            <hr style="margin: 10px 0 10px 0;">
            <h3 style="margin-bottom: 0;">La precalificación indicada tiene un participante que no EXISTE EN BANCA BT -
              CODEUDOR }</h3>
          </div>
          <div class="col-md-3 p-0">
          </div>
          <div class="col-md-1 p-0">
            <img src="../../assets/icons/Botones Politicas rojo.png" height="25px" class="vertical-center">
          </div>
        </div>
      </div>
      <div class="producto" *ngIf="precalificacionSeleccionada.estadoProceso=='OFERTA_SELECCIONADA'
      && precalificacionSeleccionada.estadoColorPrecalificacion=='VERDE'
      && participante === 1
      && clienteserviceParam.datosCodeudor.cliente.existeClienteConCodigoBantrab === 'S'
      && clienteserviceParam.datosCodeudor.cliente.existeClienteActualizado === 'N' && banderavencimiento">
        <div class="row">
          <div class="col-md-2">
            <h4>ESTADO</h4>
            <hr style="margin: 10px 0 10px 0;">
            <h4>MENSAJE</h4>
          </div>
          <div class="col-md-6 p-0">
            <h3>OFERTA SELECCIONADA</h3>
            <hr style="margin: 10px 0 10px 0;">
            <h3 style="margin-bottom: 0;">La precalificación indicada tiene un participante con datos NO actualizados -
              CODEUDOR</h3>
          </div>
          <div class="col-md-3 p-0">
          </div>
          <div class="col-md-1 p-0">
            <img src="../../assets/icons/Botones Politicas rojo.png" height="25px" class="vertical-center">
          </div>
        </div>
      </div>
    </div>
    <div style="text-align: center;margin-left: auto;margin-right: auto;width: 70%;max-width:1200px;" *ngIf="clienteserviceParam.rolABFlag">
      <button class="btn round-button" style="width: 300px !important;" (click)="enviarComprobante()">Enviar comprobante</button>
    </div>
    <div class="table-data" *ngIf="precalificacionSeleccionada.tipoProducto!='004'">
      <h2>OFERTA SELECCIONADA:
        {{precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.tipo}}
      </h2>
      <div class="table1">
        <table class="table">
          <thead class="thead-light" *ngIf="!clienteserviceParam.rolABFlag">
            <tr>
              <th scope="col">Líquido a recibir</th>
              <th scope="col">
                {{precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.liquidezRecibir|
                currency:"Q "}}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Monto:</th>
              <td>{{precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.monto|
                currency:"Q "}}
              </td>
            </tr>
            <tr>
              <th>Cuota con Seguro:</th>
              <td
                *ngIf="participante==0 && precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchFlg!='1'">
                {{precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCreditoConSeguro|
                currency:"Q "}}</td>
              <td
                *ngIf="participante==0 && precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchFlg=='1'">
                {{precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCreditoConSeguroSinMaM|
                currency:"Q "}}</td>
              <td *ngIf="participante==1">
                {{precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCreditoConSeguroSinMaMFiador|
                currency:"Q "}}</td>
            </tr>
            <tr
              *ngIf="precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchFlg=='1' && participante==0">
              <th>Ahorro Mensual:</th>
              <td>
                {{precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchAhorroMensual|
                currency:"Q "}}
              </td>
            </tr>
            <tr
              *ngIf="precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchFlg=='1' && participante==0">
              <th>Cuota Total Mensual:</th>
              <td>
                {{precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCreditoConSeguro|
                currency:"Q "}}
              </td>
            </tr>
            <tr>
              <th>Plazo:</th>
              <td>{{precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.plazo}} meses
              </td>
            </tr>
            <tr *ngIf="!clienteserviceParam.rolABFlag">
              <th>Tasa:</th>
              <td>{{ precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.tasa|number:
                '1.2-2' }}%</td>
            </tr>
            <tr *ngIf="participante === 0 && precalificacionSeleccionada.segmentoProducto!='PAGO_VOLUNTARIO'&& !clienteserviceParam.rolABFlag">
              <th>RCI Interno Final Deudor:</th>
              <td>{{
                precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.rciInternoFinalDeudor|number:'1.2-2'
                | noComma }} %</td>
            </tr>
            <tr *ngIf="participante === 0 && !clienteserviceParam.rolABFlag">
              <th>RCI Global Final Deudor:</th>
              <td>{{
                precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.rciGlobalFinalDeudor|number:'1.2-2'
                | noComma }} %</td>
            </tr>
            <tr *ngIf="participante === 1 && precalificacionSeleccionada.segmentoProducto!='PAGO_VOLUNTARIO'&& !clienteserviceParam.rolABFlag">
              <th>RCI Interno Final Codeudor:</th>
              <td>{{
                precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.rciInternoFinalFiador|number:'1.2-2'
                | noComma }} %</td>
            </tr>
            <tr *ngIf="participante === 1 && !clienteserviceParam.rolABFlag">
              <th>RCI Global Final Codeudor:</th>
              <td>{{
                precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.rciGlobalFinalFiador|number:'1.2-2'
                | noComma }} %</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table2" *ngIf="participante === 0 && !clienteserviceParam.rolABFlag">
        <table class="table">
          <thead class="thead-light">
            <tr>
              <th colspan="2" scope="col">Descuento del Crédito</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Comisión por desembolso:</th>
              <td>
                {{precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.comisionDesembolso|
                currency:"Q "}}</td>
            </tr>
            <tr>
              <th>Prima seguro anual:</th>
              <td>
                {{precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.primaSeguroAnual|
                currency:"Q "}}</td>
            </tr>
            <tr>
              <th>Prima Seguro Mensual:</th>
              <td>
                {{precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.primaSeguroMensual|
                currency:"Q "}}</td>
            </tr>
            <tr>
              <th>Interés Fin de Mes:</th>
              <td>{{precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.interesFinDeMes|
                currency:"Q "}}</td>
            </tr>
            <tr *ngIf="!clienteserviceParam.rolABFlag">
              <th>Total consolidación:</th>
              <td>{{totalconsolidacion|
                currency:"Q "}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table3" *ngIf="creditosConsolidados.length>0 && participante === 0">
        <table class="table">
          <thead class="thead-light">
            <tr>
              <th colspan="3" scope="col">Creditos Consolidados</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Tipo</th>
              <th>No.</th>
              <th>Saldo</th>
            </tr>
            <tr *ngFor="let credito of creditosConsolidados">
              <td>{{credito.tipo}}</td>
              <td *ngIf="credito.tipo=='Prestamo BT'">{{credito.noCredito}}</td>
              <td *ngIf="credito.tipo=='TC BT'">**** **** ****
                {{credito.noTarjeta.substring(credito.noTarjeta.length-4)}}</td>
              <td *ngIf="credito.tipo!='TC BT' && credito.tipo!='Prestamo BT'">{{credito.CodEntidad}}</td>
              <td>{{credito.saldo|
                currency:"Q "}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="table-data" *ngIf="precalificacionSeleccionada.tipoProducto=='004'">
      <h2>OFERTA SELECCIONADA:
        {{precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.nombreComercial}}
      </h2>
      <div class="table1">
        <table class="table">
          <thead class="thead-light">
            <tr>
              <th scope="col">Categoría</th>
              <th scope="col">
                {{precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.nombreCategoria}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="!clienteserviceParam.rolABFlag">
              <th>Minimo:</th>
              <td>{{precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.limiteInferior|
                currency:"Q "}}
              </td>
            </tr>
            <tr *ngIf="!clienteserviceParam.rolABFlag">
              <th>Maximo:</th>
              <td>
                {{precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.limiteSuperior|
                currency:"Q "}}</td>
            </tr>
            <tr *ngIf="!clienteserviceParam.rolABFlag">
              <th>Monto:</th>
              <td>
                {{precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.montoAutorizado|
                currency:"Q "}}
              </td>
            </tr>
            <tr *ngIf="!clienteserviceParam.rolABFlag">
              <th>Cuota:</th>
              <td>
                {{precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCredito|
                currency:"Q "}}
              </td>
            </tr>
            <tr *ngIf="!clienteserviceParam.rolABFlag">
              <th>RCI Final:</th>
              <td>{{ precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.rciInternoFinalDeudor|number:
                '1.2-2' }}%</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="row table-media" style="margin-top: 20px;" *ngIf="!clienteserviceParam.rolABFlag">
    <div class="col-md-6">
      <div class="table-data" style="margin-left: auto; margin-bottom: 15px;">
        <h2>RESUMEN DE CALCULOS</h2>
        <div class="table2">
          <table class="table">
            <thead class="thead-light">
              <tr>
                <th colspan="2" scope="col">RCI GLOBAL</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>INGRESOS VALIDOS:</th>
                <td>{{precalificacionSeleccionada.participante[this.participante].outIngresosValidos| currency:"Q "}}
                </td>
              </tr>
              <tr>
                <th>SALARIO LIQUIDO:</th>
                <td>{{precalificacionSeleccionada.participante[this.participante].outIngresoLiquido| currency:"Q "}}
                </td>
              </tr>
              <tr>
                <th>CUOTA TARJETA:</th>
                <td>{{precalificacionSeleccionada.participante[this.participante].outCuotaTarjetaExterna| currency:"Q
                  "}}</td>
              </tr>
              <tr>
                <th>CUOTA FACTORAJE OTROS BANCOS:</th>
                <td>{{precalificacionSeleccionada.participante[this.participante].outCuotaFactorajeOtrosBancosExterna|
                  currency:"Q "}}</td>
              </tr>
              <tr>
                <th>CUOTA FIDUCIARIOS:</th>
                <td>{{precalificacionSeleccionada.participante[this.participante].outCuotaFiduciarioExterna| currency:"Q
                  "}}
                </td>
              </tr>
              <tr>
                <th>CUOTA FIDUCIARIOS VIVIENDA</th>
                <td>{{precalificacionSeleccionada.participante[this.participante].outCuotaFiduciarioViviendaExterna|
                  currency:"Q "}}</td>
              </tr>
              <tr>
                <th>CUOTA FIDUCIARIOS PRENDARIOS:</th>
                <td>{{precalificacionSeleccionada.participante[this.participante].outCuotaFiduciarioPrendarioExterna|
                  currency:"Q "}}</td>
              </tr>
              <tr>
                <th>CUOTA VIVIENDA:</th>
                <td>{{precalificacionSeleccionada.participante[this.participante].outCuotaViviendaExterna| currency:"Q
                  "}}</td>
              </tr>
              <tr>
                <th>CUOTA PRENDARIO:</th>
                <td>{{precalificacionSeleccionada.participante[this.participante].outCuotaPrendarioExterna| currency:"Q
                  "}}
                </td>
              </tr>
              <tr>
                <th>CUOTA FIDUCIARIO BIENES PRENDARIOS:</th>
                <td>
                  {{precalificacionSeleccionada.participante[this.participante].outCuotaFiduciarioBienesPrendarioExterna|
                  currency:"Q "}}</td>
              </tr>
              <tr>
                <th>CUOTA FIDUCIARIO OTRAS GARANTIAS:</th>
                <td>
                  {{precalificacionSeleccionada.participante[this.participante].outCuotaFiduciarioOtrasGarantiasExterna|
                  currency:"Q "}}</td>
              </tr>
              <tr>
                <th>CUOTAS CONSOLIDA SIB:</th>
                <td *ngIf="participante==0">
                  {{precalificacionSeleccionada.participante[this.participante].outCuotaCreditoConsolidarExterna|
                  currency:"Q
                  "}}</td>
                <td *ngIf="participante==1">Q 0.00</td>
              </tr>
              <tr>
                <th>RCI GLOBAL INICIAL:</th>
                <td *ngIf="participante==0">
                  {{
                  precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.rciGlobalInicialDeudor
                  | number:'1.2-2' | noComma }}%</td>
                <td *ngIf="participante==1">
                  {{
                  precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.rciGlobalInicialFiador|number:
                  '1.2-2' | noComma }}%</td>
              </tr>
              <tr>
                <th>RCI GLOBAL FINAL:</th>
                <td *ngIf="participante==0">
                  {{
                  precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.rciGlobalFinalDeudor|number:'1.2-2'
                  | noComma }}%</td>
                <td *ngIf="participante==1">
                  {{
                  precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.rciGlobalFinalFiador|number:
                  '1.2-2' | noComma }}%</td>
              </tr>
              <tr>
                <th>CUOTA NUEVO CREDITO (CON SEGURO)</th>
                <td
                  *ngIf="participante==0 && precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchFlg!='1'">
                  {{precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCreditoConSeguro|
                  currency:"Q "}}</td>
                <td
                  *ngIf="participante==0 && precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchFlg=='1'">
                  {{precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCreditoConSeguroSinMaM|
                    currency:"Q "}}</td>
                <td *ngIf="participante==1">
                  {{precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCreditoConSeguroSinMaMFiador|
                  currency:"Q "}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="table-data">
        <div class="table2">
          <table class="table">
            <thead class="thead-light">
              <tr>
                <th colspan="2" scope="col">RCI INTERNO</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>CUOTAS DIRECTAS BANTRAB:</th>
                <td>{{precalificacionSeleccionada.participante[this.participante].outCuotaDeudaDirectaBT| currency:"Q
                  "}}</td>
              </tr>
              <tr>
                <th>CUOTAS INDIRECTAS BANTRAB:</th>
                <td>{{precalificacionSeleccionada.participante[this.participante].outCuotaFiduciarioIndirectoBT|
                  currency:"Q
                  "}}</td>
              </tr>
              <tr>
                <th>CUOTA HIPOTECARIA BANTRAB:</th>
                <td>{{precalificacionSeleccionada.participante[this.participante].outCuotaHipotecariosBT| currency:"Q
                  "}}</td>
              </tr>
              <tr>
                <th>CUOTA TARJETA BANTRAB:</th>
                <td>{{precalificacionSeleccionada.participante[this.participante].outCuotaTarjetaCreditoBT| currency:"Q
                  "}}
                </td>
              </tr>
              <tr>
                <th>TOTAL CUOTAS BANTRAB:</th>
                <td>{{precalificacionSeleccionada.participante[this.participante].outSumatoriaCuotasDeudasActivasBT|
                  currency:"Q "}}</td>
              </tr>
              <tr>
                <th>CUOTAS CONSOLIDADAS BANTRAB:</th>
                <td>{{precalificacionSeleccionada.participante[this.participante].outCuotaConsolidacionDeudasBT|
                  currency:"Q
                  "}}</td>
              </tr>
              <tr>
                <th>RCI INTERNO INICIAL:</th>
                <td *ngIf="participante==0">
                  {{
                  precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.rciInternoInicialDeudor|number:'1.2-2'
                  | noComma }}%</td>
                <td *ngIf="participante==1">
                  {{
                  precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.rciInternoInicialFiador|number:'1.2-2'
                  | noComma }}%</td>
              </tr>
              <tr>
                <th>RCI INTERNO FINAL:</th>
                <td *ngIf="participante==0">
                  {{
                  precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.rciInternoFinalDeudor|number:'1.2-2'
                  | noComma }}%</td>
                <td *ngIf="participante==1">
                  {{
                  precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.rciInternoFinalFiador|number:'1.2-2'
                  | noComma }}%</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="table-data" style="margin-top: 30px;" *ngIf="precalificacionSeleccionada.tipoProducto!='004'">
        <div class="table2">
          <table class="table">
            <thead class="thead-light">
              <tr>
                <th colspan="2" scope="col">LIQUIDEZ</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>LIQUIDEZ INICIAL:</th>
                <td>{{precalificacionSeleccionada.participante[this.participante].outLiquidezInicial| currency:"Q "}}
                </td>
              </tr>
              <tr>
                <th>LIQUIDEZ FINAL:</th>
                <td>{{setLiquidezFinal()| currency:"Q "}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>